module.exports = __webpack_public_path__ + "static/media/callpop-logo-white.ad1f83e5.webp";